/*
*   主图预览组件
*   zxw
*   2024-08-21
*/

import React , { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config';
import { message,
    Modal, 
    Image,} from 'antd';
import { UjoinParams, AddRequestHeaders, 
    AliyunOSSclient} from '../../incs/FunHelper.js';

const WalkwayImagePreview = (props) => {
    const [open, setOpen] = useState(false);
    const [imageSrc, setImageSrc] = useState('');
    const [path,setPath] = useState('');

    /**
     * 从阿里云下载
     * @param {*} file
     */
    const aliyunOSSDownload = (file) =>{
        var params = {
            'oss': 'GetObject'
        }
        $.ajax({
            url: CNF.api + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET',success:function(data){
                if(data.res === 0){
                    const token = data.dat;
                    try {
                        //  去掉路径‘/’
                        let result = AliyunOSSclient(token).signatureUrl(file.path, {
                            expires: 3600,
                            response: {
                                'content-disposition': 'attachment; filename="' + file.name + '"'
                            }
                        });
                        setImageSrc(result);
                    } catch (e) {
                        console.log(e);
                    }
                }else{
                    message.error(data.msg, 1);
                }
            }
        });
    }

    useEffect(() => {
        if(props.record.path !== path){
            aliyunOSSDownload({
                name: props.record.name,
                path: props.record.path,
            });
            setPath(props.record.path);
        }
        setOpen(true);
        
    }, [props]);


 
    return (
        <Modal
            width={600}
            style={{ top: 0,padding: 0,}}
            // title={props.record.name}
            closable={false}
            open={open}
            keyboard={true}
            maskClosable={true}
            onCancel={()=>{setOpen(false);}}
            footer={null}
        >
            <div style={{
                width: 600,
                position: 'relative',
                borderRadius: 8,
                top: 0,
                margin: '-20px -24px',
            }}>
                <Image style={{ borderRadius: 8, }} src={imageSrc} preview={false}/>
            </div>
        </Modal>
    );
};

export default WalkwayImagePreview;